import { Component } from '@angular/core';
import { CalioFlatButtonComponent } from '@calio-lib/calio-button/calio-flat-button/calio-flat-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forbidden-page',
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.scss'],
  imports: [TranslateModule, CalioFlatButtonComponent]
})
export class ForbiddenPageComponent {}
